import React from 'react';
import MyCard from '../../Common/MyCard';
import AddFonctionnalite from './AddFonctionnalite';
import ListeFonctionnalite from './ListeFonctionnalite';

const Fonctionnalite = () => {
    return (
        <div>
            <MyCard
                titleCard="Fonctionnalite"
                addComponent={<AddFonctionnalite />}
                content={<ListeFonctionnalite /> }
            />
        </div>
    );
}

export default Fonctionnalite;
